import { makeHttpRequest } from "@/shared";

export const deleteInventoryStatuses = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/inventory/state/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
